import { Reducer } from "../../lib/redux";
import { IDeviceLink } from "../../model/DeviceLink";
import { extend } from "../../utils/vanilla";
import { DeviceLinkActions } from "./actions";
import { DeviceLinkActionTypes } from "./types";

export let deviceLinks: Reducer<IIdDictionary<IIdDictionary<IDeviceLink>>, DeviceLinkActions> = (state = {}, action) => {
    switch (action.type) {
        case DeviceLinkActionTypes.SET_DEVICE_LINKS: {
            const userId = action.payload.userId;
            if (userId) {
                return {
                    ...state,
                    [userId]: extend(true, {}, action.payload.deviceLinks) || {}
                };
            }
            return state;
        }
        case DeviceLinkActionTypes.CLEAR_DEVICE_LINKS: {
            // only remove if payload contains userId
            if (action.payload) {
                let cloneState = { ...state };
                delete cloneState[action.payload];
                return cloneState;
            }
            return {};
        }
        default:
            return state;
    }
};